// Hubita Color System — Facelift Edition
// Extended to match Figma design tokens while preserving legacy keys

const tintColorLight = '#6C2BD9';
const tintColorDark = '#fff';

export default {
  light: {
    // Legacy keys (kept for backward compatibility)
    text: '#111827',
    background: '#F5F7FB',
    tint: tintColorLight,
    tabIconDefault: '#9CA3AF',
    tabIconSelected: tintColorLight,
    gradientColor1: '#7002BC',
    purple: '#6C2BD9',
    lightPurple: '#A070C4',
    red: '#EF4444',
    white: '#FFFFFF',

    // New Figma-aligned tokens
    primary: '#6C2BD9',
    primaryLight: '#F0E8FF',
    surface: '#FFFFFF',
    appBg: '#F5F7FB',
    textPrimary: '#111827',
    textSecondary: '#6B7280',
    border: '#E5E7EB',
    success: '#10B981',
    warning: '#F59E0B',
    danger: '#EF4444',
  },
  dark: {
    text: '#fff',
    background: '#000',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
    purple: '#6C2BD9',
    lightPurple: '#A070C4',
  },
};
